import { Link } from "react-router-dom";
import BgShape from "../images/hero/iconos4.png";

import Logo from "../images/logo/Tramitesseguros-03.png";
// import HeroCar from "../images/hero/main-car.png";
import { useEffect, useState } from "react";

function Hero() {
  const [goUp, setGoUp] = useState(false);

  
  const scrollToTop = () => {
    window.scrollTo({ top: (0, 0), behavior: "smooth" });
  };

  const bookBtn = () => {
    document
      .querySelector("#booking-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const onPageScroll = () => {
      if (window.pageYOffset > 600) {
        setGoUp(true);
      } else {
        setGoUp(false);
      }
    };
    window.addEventListener("scroll", onPageScroll);

    return () => {
      window.removeEventListener("scroll", onPageScroll);
    };
  }, []);
  return (
    <>
   
      <section id="home" className="hero-section">
        <div className="container">
          <img className="bg-shape" src={BgShape} alt="bg-shape" />
          <div className="hero-content">
            <div className="hero-content__text">
            <img  src={Logo} alt="logo-img" />
              <h1>
                Contáctanos <span>Trámites Seguros</span> Lo resuelve por Ti
              </h1>
              <p>
                Nuestra atención es totalmente personalizada <br/> y te brindamos
                el asesoramiento que necesitas
          
              </p>
              <div className="hero-content__text__btns">
                <Link
                  
                  className="hero-content__text__btns__book-ride"
                  to="/contact"
                >
                  Contactanos &nbsp; <i className="fa-solid fa-circle-check"></i>
                </Link>
                {/* <Link className="hero-content__text__btns__learn-more" to="/servicios">
                  Mira Nuestros Servicios &nbsp; <i className="fa-solid fa-angle-right"></i>
                </Link> */}
                 
              </div>
            </div>

            {/* img */}
            {/* <img */}
             {/* src={HeroCar} //  */}
              {/* alt="car-img" */}
              {/* className="hero-content__car-img" */}
            {/* /> */}
          </div>
        </div>

        {/* page up */}
        <div
          onClick={scrollToTop}
          className={`scroll-up ${goUp ? "show-scroll" : ""}`}
        >
          <i className="fa-solid fa-angle-up">^</i>
        </div>
      </section>
    </>
  );
}

export default Hero;
